import { createAsyncThunk } from '@reduxjs/toolkit';
import CalendarService from '@/services/CalendarService';
import ContactsService from '@/services/ContactsService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`Calendar-events/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getTypes = handler('getTypes', CalendarService.getEventsTypes);

export const getClosures = handler('getClosures', CalendarService.getClosures);

export const getAgent = handler('getAgent', CalendarService.getAgent);

export const getAgents = handler('getAgents', CalendarService.getAgents);

export const getProperties = handler(
  'getProperties',
  CalendarService.getProperties
);

export const getContact = handler('getContact', ContactsService.getContact);

export const getContacts = handler('getContacts', ContactsService.getContacts);

export const getProperty = handler('getProperty', CalendarService.getProperty);

export const getEvents = handler('getEvents', CalendarService.getEvents);

export const getEvent = handler('getEvent', CalendarService.getEvent);

export const getEventWithClosures = handler(
  'getEventWithClosures',
  CalendarService.getEventWithClosures
);

export const createEvent = handler('createEvent', CalendarService.createEvent);

export const deleteEvent = handler('deleteEvent', CalendarService.deleteEvent);

export const eventDone = handler('eventDone', CalendarService.eventDone);

export const eventDoneWithClosure = handler(
  'eventDoneWithClosure',
  CalendarService.eventDoneWithClosure
);

export const editEvent = handler('editEvent', CalendarService.editEvent);

export const excludeDates = handler(
  'excludeDates',
  CalendarService.excludeDates
);

export const editOneInstance = handler(
  'editOneInstance',
  CalendarService.editOneInstance
);

export const doneOneInstance = handler(
  'doneOneInstance',
  CalendarService.doneOneInstance
);

export const confirmVisit = handler(
  'confirmVisit',
  CalendarService.confirmVisit
);
